import {
    filters,
    jsonApiFields,
    jsonApiFilter,
    jsonApiInclude,
    jsonApiSort,
    preprocessJsonApiQuery,
} from '@dmp/shared/json-api-request';
import { paginationOptionsSchema } from '@dmp/shared/types';
import z from 'zod';

export const feedsFilter = filters({
    name: { type: 'like' },
    combined: { type: 'like', field: 'name' },
});

export const feedsQueryValidator = z.preprocess(
    preprocessJsonApiQuery,
    z.object({
        fields: jsonApiFields,
        filter: jsonApiFilter(feedsFilter),
        include: jsonApiInclude(['entries', 'updatedBy']),
        page: paginationOptionsSchema,
        sort: jsonApiSort(['name', 'createdAt', 'updatedAt']),
    })
);

export type FeedsQuery = z.output<typeof feedsQueryValidator>;
